import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NbThemeModule, NbUserModule, NB_JS_THEMES, NB_THEME_OPTIONS, NbPopoverModule } from '@nebular/theme';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgChartsModule } from 'ng2-charts';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AutofocusDirective } from './directives/autofocus.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import { DisableRightClickDirective } from './directives/disable-right-click.directive';
import { DeviceFilterPipe } from './pipes/device-filter.pipe';
import { DeviceSortPipe } from './pipes/device-sort.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { SecondsToDaysPipe } from './pipes/seconds-to-days.pipe';
import { TransferPipe } from './pipes/transfer.pipe';
import { UtcToLocaleDateTimePipe } from './pipes/utc-to-locale-date-time.pipe';
import { SortByOrderPipe } from './pipes/sort-by-order.pipe';
import { CatalogFilterPipe } from './pipes/catalog-filter.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { ExtractUsedMaterialsPipe } from './pipes/extract-used-materials.pipe';
import { BarComponent } from './components/charts/bar/bar.component';
import { DoughnutComponent } from './components/charts/doughnut/doughnut.component';
import { ControlMessagesComponent } from './components/control-messages/control-messages.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { RangeSliderComponent } from './components/range-slider/range-slider.component';
import { ConfirmationsModalComponent } from './modals/confirmations-modal/confirmations-modal.component';
import { SortByPipe } from './pipes/sort-by.pipe';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import {
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbLayoutModule,
  NbDialogModule,
  NbIconModule,
  NbInputModule,
  NbSpinnerModule,
  NbToastrModule,
  NbTooltipModule,
  NbAccordionModule,
  NbProgressBarModule,
  NbOptionModule,
  NbCheckboxModule,
  NbSelectModule,
  NbFormFieldModule,
  NbMenuModule,
} from '@nebular/theme';
import { ThemeHelper } from './helpers/theme.helper';
import { baseTheme } from './styles/base.theme';
import { clinicalTheme } from './styles/clinical.theme';
import { SerialNumberWithDeviceTypePipe } from './pipes/serial-number-with-device-type.pipe';
import { PrintDetailsModalComponent } from './modals/print-details-modal/print-details-modal.component';
import { ImgFallbackDirective } from './directives/img-fallback.directive';

@NgModule({
  declarations: [
    ClickStopPropagationDirective,
    ClickOutsideDirective,
    UtcToLocaleDateTimePipe,
    SecondsToDaysPipe,
    DeviceFilterPipe,
    DeviceSortPipe,
    FileSizePipe,
    AutofocusDirective,
    TransferPipe,
    DisableRightClickDirective,
    SortByOrderPipe,
    SortByPipe,
    CatalogFilterPipe,
    SafePipe,
    EnumToArrayPipe,
    ExtractUsedMaterialsPipe,
    BarComponent,
    DoughnutComponent,
    ControlMessagesComponent,
    PaginationComponent,
    RangeSliderComponent,
    ConfirmationsModalComponent,
    ToggleSwitchComponent,
    SerialNumberWithDeviceTypePipe,
    PrintDetailsModalComponent,
    ImgFallbackDirective
  ],
  imports: [
    FormsModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    NbUserModule,
    NbTooltipModule,
    NbBadgeModule,
    NbIconModule,
    NbLayoutModule,
    NbCardModule,
    NbThemeModule.forRoot(),
    NbDialogModule.forChild(),
    NbToastrModule.forRoot(),
    NbSpinnerModule,
    NbInputModule,
    NbButtonModule,
    NbAccordionModule,
    NbProgressBarModule,
    NbOptionModule,
    NbCheckboxModule,
    NbSelectModule,
    NgxDaterangepickerMd.forRoot(),
    ClipboardModule,
    NgChartsModule,
    NbFormFieldModule,
    NbMenuModule,
    NbPopoverModule
  ],
  exports: [
    RouterModule,
    TranslateModule,
    NbUserModule,
    NbTooltipModule,
    NbBadgeModule,
    NbIconModule,
    NbLayoutModule,
    ClickStopPropagationDirective,
    ClickOutsideDirective,
    UtcToLocaleDateTimePipe,
    NbCardModule,
    NbToastrModule,
    NbDialogModule,
    NbSpinnerModule,
    NbInputModule,
    NbButtonModule,
    NbCardModule,
    FormsModule,
    ReactiveFormsModule,
    NbAccordionModule,
    SecondsToDaysPipe,
    NbProgressBarModule,
    DeviceFilterPipe,
    DeviceSortPipe,
    NbOptionModule,
    NgxDaterangepickerMd,
    ClipboardModule,
    NbSelectModule,
    NbCheckboxModule,
    FileSizePipe,
    NbFormFieldModule,
    AutofocusDirective,
    NgChartsModule,
    TransferPipe,
    SortByOrderPipe,
    SortByPipe,
    CatalogFilterPipe,
    SafePipe,
    EnumToArrayPipe,
    NbMenuModule,
    BarComponent,
    DoughnutComponent,
    ControlMessagesComponent,
    PaginationComponent,
    RangeSliderComponent,
    ConfirmationsModalComponent,
    ToggleSwitchComponent,
    SerialNumberWithDeviceTypePipe,
    NbPopoverModule,
    ImgFallbackDirective
  ],
  providers: [
    TranslatePipe,
    SortByOrderPipe,
    ExtractUsedMaterialsPipe,
    {
      provide: NB_THEME_OPTIONS,
      useValue: { name: ThemeHelper.theme }
    },
    { 
      provide: NB_JS_THEMES,
      useValue: [
        { name: 'roboze_incloud', base: 'corporate', variables: baseTheme },
        { name: 'roboze_incloud_clinical', base: 'roboze_incloud', variables: clinicalTheme },
      ]
    },
  ]
})
export class SharedModule { }
